export default "__VITE_ASSET__CEtMjQks__"